import { z } from "zod"
import { EMAIL_MAX_LENGTH } from "@/modules/patients/constants/Patient"

const Doc2USchema = z.object({
  email: z
    .email({ message: "common.fieldErrorList.invalidEmail" })
    .min(1, { message: "common.fieldErrorList.requiredField" })
    .max(EMAIL_MAX_LENGTH, { message: "common.fieldErrorList.characterLimit" }),
})

type Doc2UFormData = z.infer<typeof Doc2USchema>

export { Doc2USchema, type Doc2UFormData }
